<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="title-chart">Tren Pendaftaran Member Baru</span>
      <a-select v-model:value="selectedFilter" class="custom-year-select" style="width: 190px">
        <a-select-option value="last12">1 Tahun Terakhir</a-select-option>
        <a-select-option v-for="year in yearOptions" :key="year" :value="String(year)">
          {{ year }}
        </a-select-option>
      </a-select>
    </div>

    <a-spin :spinning="loading">
      <div v-if="!hasData" class="empty-state">
        <p>Tidak ada data tersedia</p>
      </div>
      <apexchart v-else type="area" height="350" :options="chartOptions" :series="chartSeries" />
    </a-spin>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import moment from 'moment'
import { mobileCmsMemberApplicationAPI } from '@/services/axios/perki/mobileCms'

export default {
  name: 'TrenPendaftaranMember',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const currentYear = moment().year()
    const selectedFilter = ref(String(currentYear))
    const loading = ref(false)
    const hasData = ref(false)

    const apiData = ref(null)
    const yearOptions = Array.from(
      { length: currentYear - 2021 + 1 },
      (_, index) => currentYear - index,
    )

    const chartSeries = computed(() => {
      if (apiData.value?.data) {
        return [
          {
            name: 'Jumlah Pendaftar',
            data: apiData.value.data,
          },
        ]
      }
      return []
    })

    const categories = computed(() => {
      if (apiData.value?.categories) {
        return apiData.value.categories
      }
      return []
    })

    const chartOptions = computed(() => ({
      chart: {
        type: 'area',
        toolbar: {
          show: false,
        },
      },
      dataLabels: { enabled: false },
      stroke: {
        curve: 'straight',
        width: 3,
      },
      colors: ['#C34F6B'],
      fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.8,
          opacityTo: 0.3,
        },
      },
      markers: {
        size: 5,
        hover: {
          size: 5,
        },
      },
      grid: {
        borderColor: '#E9E9E9',
        strokeDashArray: 4,
      },
      xaxis: {
        categories: categories.value,
        title: {
          text: 'Bulan',
          style: { fontSize: '12px', fontWeight: 500 },
        },
      },
      yaxis: {
        title: {
          text: 'Jumlah Pendaftar',
          style: { fontSize: '12px', fontWeight: 500 },
        },
      },
      legend: { show: false },
      tooltip: {
        y: {
          formatter: val => `${val} pendaftar`,
        },
      },
    }))

    const fetchData = async () => {
      loading.value = true
      try {
        const params = selectedFilter.value === 'last12' ? {} : { year: selectedFilter.value }

        const { data } = await mobileCmsMemberApplicationAPI.getMembershipTrend(params)
        const result = data?.result

        if (
          result?.data &&
          Array.isArray(result.data) &&
          result?.categories &&
          Array.isArray(result.categories)
        ) {
          apiData.value = {
            data: result.data,
            categories: result.categories,
          }
          hasData.value = true
        } else {
          hasData.value = false
        }
      } catch (error) {
        console.error('Error fetching membership trend:', error)
        hasData.value = false
      } finally {
        loading.value = false
      }
    }

    // Fetch on mount
    onMounted(() => {
      if (props.data) {
        apiData.value = props.data
        hasData.value = true
        return
      }

      fetchData()
    })

    watch(selectedFilter, () => {
      if (props.data) return
      fetchData()
    })

    return {
      selectedFilter,
      yearOptions,
      loading,
      chartSeries,
      chartOptions,
      hasData,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../style.scss';

.title-chart {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}

:deep(.apexcharts-text) {
  font-family: 'Lato' !important;
  font-size: 12px !important;
}

:deep(.apexcharts-text) {
  font-family: 'Lato' !important;
  font-size: 12px !important;
}

:deep(.apexcharts-yaxis-title-text),
:deep(.apexcharts-xaxis-title-text) {
  color: #667085 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}
</style>
